import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
import Sidebar from "./BusinessSidebar";
import ProfileCard from "./profile";
import MobileNBottomNav from "./MobileBottomNav";

export default function BusinessProfile() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState("profile");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    switch (page) {
      case "home":
        navigate("/loggedinartistbussiness");
        break;
      case "calendar":
        navigate("/businessCalendar");
        break;
      case "qr":
        navigate("/BusinessQr");
        break;
      case "rewards":
        navigate("/rewards");
        break;
      case "profile":
        navigate("/businessProfile");
        break;
      default:
        break;
    }
  };

  return (
    <div className="flex min-h-screen bg-white w-full relative lg:mt-0 mt-16">
      <MobileNBottomNav />
      <div className="fixed top-0 left-0 z-50 w-full px-2 py-3 flex items-center justify-between bg-logo backdrop-blur-sm lg:hidden">
        {/* Static Title and Logo */}

        <div className="flex items-center gap-2">
          <img alt="" src="/images/tringbox-logo.png" className="h-6" />
        </div>

        {/* Animated Toggle Button */}
        <motion.button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className="p-2 rounded-md"
          aria-label="Toggle sidebar"
        >
          {isSidebarOpen ? (
            <X size={24} className="text-white" />
          ) : (
            <Menu size={24} className="text-white" />
          )}
        </motion.button>
      </div>

      {/* Sidebar */}
      <div
        className={`fixed left-0 top-0 w-80 h-full z-40 transition-transform duration-300 ease-in-out lg:translate-x-0 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <Sidebar currentPage={currentPage} onPageChange={handlePageChange} />
      </div>
      {/* Main Content */}
      <main className="flex-1 min-h-screen lg:ml-80 flex flex-col w-full bg-white">
        <ProfileCard />
      </main>
    </div>
  );
}
